import { SyntheticEvent } from 'react';
import { Tab, Tabs as MuiTabs, TabsProps } from '@mui/material';
import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

interface TabItem {
  label: string | number;
  value: string | number;
}

interface CustomTabsProps extends Omit<TabsProps, 'value' | 'onChange'> {
  tabs: TabItem[];
  value: string | number;
  onChange: (event: SyntheticEvent, newValue: string | number) => void;
}

export default function Tabs({ tabs, value, onChange, ...rest }: CustomTabsProps) {
  return (
    <StyledTabs variant="fullWidth" value={value} onChange={onChange} {...rest}>
      {tabs.map(({ label, value }) => (
        <StyledTab key={value} disableRipple label={label} value={value} />
      ))}
    </StyledTabs>
  );
}

const StyledTabs = styled(MuiTabs)(() => ({
  width: '100%',
  minHeight: 'unset',
  height: '32px',
  marginBottom: '16px',
  position: 'relative',
  '&:before': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '1px',
    backgroundColor: COLORS.grey200,
  },
  '.MuiTabs-indicator': {
    backgroundColor: COLORS.black,
    height: '1px',
  },
}));

const StyledTab = styled(Tab)(() => ({
  textTransform: 'none',
  padding: '6px 10px 2px 10px',
  fontSize: '13px',
  fontWeight: 500,
  color: COLORS.grey400,
  minHeight: 'unset',
  '&.Mui-selected': {
    color: COLORS.textMain,
  },
}));
